/**
 * Handles the Quick Search form logic.
 * Disables submit button until fields are selected.
 * Redirects to constructed URL on submit.
 * 
 * @param {HTMLElement|Document} context - The container to scope the initialization to.
 */
export function initializeQuickSearch(context = document) {
    const forms = context.querySelectorAll('.quick-search');

    forms.forEach(form => {
        // Avoid double init
        if (form.classList.contains('js-quick-search-init')) return;
        form.classList.add('js-quick-search-init');

        const actionSelect = form.querySelector('select[name="search_action"]');
        const typeSelect = form.querySelector('select[name="property_type"]');
        const submitBtn = form.querySelector('button[type="submit"]');

        if (!actionSelect || !typeSelect || !submitBtn) return;

        // Faux select elements for property type
        const typeFauxSelect = typeSelect.nextElementSibling;
        const typeFauxOptions = typeFauxSelect ? typeFauxSelect.querySelectorAll('.faux-select__option') : [];
        const typeFauxLabel = typeFauxSelect ? typeFauxSelect.querySelector('.faux-select__label') : null;
        const typeDefaultLabel = typeSelect.options[0].text;

        const updateState = () => {
            if (actionSelect.value !== '' && typeSelect.value !== '') {
                submitBtn.removeAttribute('disabled');
            } else {
                submitBtn.setAttribute('disabled', 'disabled');
            }
        };

        const filterSecondaryOptions = (e) => {
            const parentValue = actionSelect.value;

            // Reset secondary selection
            typeSelect.value = '';
            
            // Reset label
            if (typeFauxLabel) {
                typeFauxLabel.childNodes[0].textContent = typeDefaultLabel;
            }

            // Toggle disabled state
            const typeTrigger = typeFauxSelect ? typeFauxSelect.querySelector('.faux-select__trigger') : null;
            
            if (!parentValue) {
                typeSelect.setAttribute('disabled', 'disabled');
                if (typeTrigger) typeTrigger.setAttribute('disabled', 'disabled');
                if (typeFauxSelect) typeFauxSelect.classList.add('disabled');
            } else {
                typeSelect.removeAttribute('disabled');
                if (typeTrigger) typeTrigger.removeAttribute('disabled');
                if (typeFauxSelect) typeFauxSelect.classList.remove('disabled');

                if (e && e.type === 'change' && typeTrigger) {
                    setTimeout(() => {
                        typeTrigger.click();
                    }, 100);
                }
            }

            // Filter faux options
            typeFauxOptions.forEach(opt => {
                if (parentValue && opt.dataset.parent === parentValue) {
                    opt.style.display = '';
                } else {
                    opt.style.display = 'none';
                }
            });

            // Filter native options
            Array.from(typeSelect.options).forEach(opt => {
                if (opt.value === '') return;
                if (parentValue && opt.dataset.parent === parentValue) {
                    opt.hidden = false;
                    opt.disabled = false;
                } else {
                    opt.hidden = true;
                    opt.disabled = true;
                }
            });

            updateState();
        };

        // Initial state
        filterSecondaryOptions();

        // Listen for changes on native selects (triggered by faux-select.js)
        actionSelect.addEventListener('change', filterSecondaryOptions);
        typeSelect.addEventListener('change', updateState);

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            
            const url = typeSelect.value;
            if (url) {
                window.location.href = url;
            }
        });
    });
}